import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VCard,{attrs:{"flat":""}},[_c(VSkeletonLoader,{attrs:{"type":"card-heading"}}),_c(VCardText,[_c(VSkeletonLoader,{attrs:{"type":"text"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }